module.exports = __webpack_public_path__ + "img/sepa.4eb401d3.svg";